import { GroupsModalComponent } from 'pages/Settings/modals/GroupsModal/GroupsModal.component';
import {
  GroupsModalDataProvider,
  GroupsModalEmptyDataProvider,
} from 'pages/Settings/modals/GroupsModal/GroupsModal.data.context';
import {
  GroupsDetailsUIProvider,
  useGroupsDetailsModalUIContext,
} from 'pages/Settings/modals/GroupsModal/GroupsModal.ui.context';

import { FC } from 'react';
import { useLocation } from 'react-router-dom';

export const GroupsModalView: FC = () => {
  const { groupId } = useGroupsDetailsModalUIContext();

  const { pathname } = useLocation();
  const location_id = pathname.split('/')[3];

  if (!location_id || !groupId) {
    return (
      <GroupsModalEmptyDataProvider>
        <GroupsModalComponent />
      </GroupsModalEmptyDataProvider>
    );
  }
  return (
    <GroupsModalDataProvider>
      <GroupsModalComponent />
    </GroupsModalDataProvider>
  );
};
export const GroupsModal: FC = () => {
  return (
    <GroupsDetailsUIProvider>
      <GroupsModalView />
    </GroupsDetailsUIProvider>
  );
};
